import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import Results from "src/pages/SearchPage/sub-components/Results";

export const StyledMenuList = styled.div`
  overflow-y: auto;
  padding-bottom: 1px;
  padding-top: 0;
  position: relative;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  max-height: 80vh;
`;

const MenuList = ({ innerRef, innerProps, selectProps }) => {
  const {
    resultsFormattedData,
    loadingPeople,
    loadingTeams,
    loadingTags,
    debouncedSearchTerm,
    workspace,
    showExploreLink,
    searchError,
    emptyStateComponent,
    onLoadMore,
    filterTypes,
  } = selectProps;

  return (
    <StyledMenuList ref={innerRef} {...innerProps} id="react-select-menu">
      <Results
        formattedData={resultsFormattedData}
        isLoadingPeople={loadingPeople}
        isLoadingTeams={loadingTeams}
        isLoadingTags={loadingTags}
        searchFilter={filterTypes.ALL}
        searchTerm={debouncedSearchTerm}
        workspace={workspace}
        compactViewMore
        showExploreLink={showExploreLink}
        searchError={searchError}
        emptyStateComponent={emptyStateComponent}
        onLoadMore={onLoadMore}
      />
    </StyledMenuList>
  );
};

MenuList.propTypes = {
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
  ]),
  selectProps: PropTypes.object,
};

export default MenuList;
